import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectsService } from './owner';

@NgModule({
  imports: [CommonModule],
  providers: [ProjectsService],
})
export class ManagerClientModule {}
